<template>
  <div class="onepay">
    <v-head></v-head>
    <div class="contentBox">
      <div class="detailsBox" v-if="info">
        <div class="detailsTit">
          <p class="left"><span>产品名称</span>{{ info.plan.productName }}</p>
          <p class="right">
            <span>应付总额： </span>{{ info.policyMoney }} 元
            <span class="cutShow" @click="cutShow">
              详情<i class="el-icon-arrow-down"></i>
            </span>
          </p>
        </div>
        <div class="detailsCon" v-show="show">
          <p>保险公司：{{ info.companyName }}</p>
          <p>职业类别：{{ info.workCate }}</p>
          <p>{{ info.plan.death_quota }}</p>
          <p>{{ info.plan.loss_work_cost }}</p>
          <p>{{ info.plan.medical_quota }}</p>
          <p>{{ info.plan.hospital_allowance }}</p>
          <p>{{ info.plan.legal_fees }}</p>
          <p>流水号：{{ info.numId }}</p>
          <p>渠道标识：{{ info.adminName }}</p>
          <p>保障期限：{{ info.sTime }} - {{ info.eTime }}</p>
        </div>
      </div>
      <div class="stepBox">
        <p>
          <img src="@/assets/images/product/stepbg1.png" alt="" />
          <span><i class="el-icon-success"></i> 1、填写投保信息 </span>
        </p>
        <p class="activate">
          <img src="@/assets/images/product/hr_stepbg2_a.png" alt="" />
          <span> 2、支付保费 </span>
        </p>
        <p>
          <img src="@/assets/images/product/stepbg3.png" alt="" />
          <span> 4、完成 </span>
        </p>
      </div>
      <pay :id="numId" :numId="numId"></pay>
    </div>
  </div>
</template>
<script>
import vHead from "@/components/vhead";
import pay from "@/components/common/pay";
import { getOrderInfo } from "@/api/guarantee";
export default {
  name: "onepay",
  components: {
    pay,
    vHead
  },
  data() {
    return {
      show: false,
      numId: "",
      info: ""
    };
  },
  created() {
    this.numId = this.$route.query.numId;
    this.getOrderInfo();
  },
  methods: {
    // 详情显示隐藏
    cutShow() {
      if (this.show) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    //获取订单详情
    getOrderInfo() {
      let that = this;
      getOrderInfo({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.info = res.data;
            // 设置title
            document.title = "支付--" + res.data.applicationName;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
.onepay {
  width: 100%;
  background: #eff2f4;
  background-image: url("~@/assets/images/product/main-bg.png");
  background-size: cover;
  padding-top: 54px;
  min-height: 100vh;
  & > .contentBox {
    width: 100%;
    max-width: 1200px;
    margin: 35px auto;
    background: #ffffff;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.07);
    border-radius: 10px;
    overflow: hidden;
    .detailsBox {
      padding: 0 24px;
      .detailsTit {
        border-bottom: 1px dotted #9797974d;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0 10px;
        & > .left {
          font-size: 22px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
          margin: 0;
          span {
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
            background-image: linear-gradient(to right, #ff9a5d, #f66735);
            border-radius: 15px 0px 15px 0px;
            display: inline-block;
            padding: 0 20px;
            margin-right: 5px;
            line-height: 24px;
            margin-right: 15px;
            display: inline-block;
          }
        }
        & > .right {
          font-size: 24px;
          font-weight: 600;
          color: #f76a37;
          margin: 0;
          span {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
          }
          .cutShow {
            padding: 15px 0 15px 15px;
            display: inline-block;
            cursor: pointer;
          }
        }
      }
      .detailsCon {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 30px;
        padding: 15px;
        p {
          margin: 0;
        }
      }
    }
    .stepBox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 25px 0 40px;
      p {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        width: 220px;
        height: 36px;
        margin: 0;
        img {
          width: 100%;
          height: 100%;
        }
        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          text-align: center;
          i {
            font-size: 20px;
            color: #55d091;
            vertical-align: middle;
          }
        }
      }
      p + p {
        margin-left: -10px;
      }
      p.activate {
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }
}
</style>
